import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import { Box } from "@mui/material";
import useColors from "../../../api/hooks/useColors";

const ImportanceCell = ({ value, row }) => {
  const colors = useColors();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {[1, 2, 3, 4, 5].map((star) =>
        star <= value ? (
          <Box
            key={star + row?.tenant_id}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "18px",
              height: "18px",
            }}
          >
            <StarRateRoundedIcon
              key={star + row?.tenant_id}
              sx={{
                color: colors.rating_checked_enabled,
                width: "14px",
                height: "14px",
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "18px",
              height: "18px",
            }}
          >
            <StarRateRoundedIcon
              key={star + row?.tenant_id}
              sx={{
                color: colors.rating_unchecked_enabled,
                width: "14px",
                height: "14px",
              }}
            />
          </Box>
        )
      )}
    </Box>
  );
};

export default ImportanceCell;
